export const columnStructure = {
    flexDirection: 'column-reverse',
    flexWrap: 'nowrap',
    textAlign: 'center',
    mr: 2
}

export const mainChartContainer = {
    display: 'flex', 
    flexWrap: 'nowrap !important',
    overflowY: 'hidden'
}

export const textDynamic = {
    display: 'flex', 
    height: '30px', 
    alignItems: 'center',
    div: {
        whiteSpace: 'nowrap', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis'
    }
}

export const bgChart = (column, length) => ({
    background: 'linear-gradient(0deg, #F0F0F0, #F0F0F0 30px, #F0F0F0 30px, #F0F0F0)', 
    display: 'flex',
    flexDirection: column ? 'column' : 'row', 
    mb: 6,
    cursor: 'pointer'
})

export const diffStyle = positiveDiff => ({
    p: '2px !important',
    background: (positiveDiff ? '#08ad6c' : '#E95455') + ' !important',
    color: '#FFF !important'
})

export const styleDisabled = color => ({
    background: `repeating-linear-gradient(45deg, #FFF, #FFF 1px, ${color}80 1px, ${color}80 3px)`,
    a: {
        span: {
            color: '#4B4B4B'
        }
    }
})

export const styleShareItem = (column, percentage, color, active) => ({
    width: `${!column ? percentage >= 0.5 ? percentage : 0.5 : '100'}%`,
    height: `${column ? percentage >= 0.5 ? percentage * 5.5 : 0.5 : '30'}px`,
    backgroundColor: color,
    position: 'relative',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontWeight: '600',
    overflow: 'visible',
    animation: '2s shareBarWidth ease-in-out',
    "@keyframes shareBarWidth": {
        "0%": {
            opacity: "0",
            maxWidth: "0"
        },
        "100%": {
            opacity: "1",
            maxWidth: "100%"
        }
    },
    animationFillMode: 'forwards',
    zIndex: '1',
    ... !active ? styleDisabled(color) : null
})

export const styleShareLabel = (column, percentage) => ({
    position: 'absolute',
    top: '0',
    right: '0',
    left: '0',
    textAlign: 'right',
    borderRight: !column ? '1px solid #4B4B4B' : '0',
    pt: 4,
    pb: 0.5,
    px: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: percentage < 2 ? 'transparent' : 'inherit'
})

export const styleShareDiff = {
    position: 'absolute',
    bottom: '0',
    right: '0',
    textAlign: 'right',
    px: 0.4,
    overflow: 'hidden',
    fontSize: '0.8rem',
    color: '#FFF',
    whiteSpace: 'nowrap'
}

export const styleShareValue = (column, percentage, active) => ({
    display: 'block',
    fontSize: 15,
    fontWeight: 'bolder',
    color: percentage < 2 ? 'transparent' : (active ? '#FFF' : '#212B36'),
    position: 'relative',
    zIndex: '2',
    py: !column ? 0.4 : 0
})